import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { group, groupModel} from '../../model/groupModel';;
import {personModel} from '../../model/personModel';


@Component({
    templateUrl: 'groupsPage.html'
})
export class groupsPage implements OnInit , OnChanges{
    perm: any;
    constructor(
        public gpModel: groupModel,
        public per: personModel
    ) {
        console.log(per);
        this.perm = per;
    }
    ngOnChanges(changes: SimpleChanges) {
        console.log(changes);
    }
    fire() {
        console.log(this.per);
        this.perm.update();
    }
    ngOnInit() {
        console.log(this.per);
    }
}



// WEBPACK FOOTER //
// ./src/pages/groups/groupsPage.ts